"use client"

import { useEffect, useState, type CSSProperties } from "react"

const AIR = 15

export const usePinnedPanel = (active = true): CSSProperties => {
  const [pan, setPan] = useState(0)
  useEffect(() => {
    if (!active) return
    const viewport = window.visualViewport
    const measure = () => setPan(Math.round(viewport?.offsetTop ?? 0))
    measure()
    window.addEventListener("resize", measure)
    viewport?.addEventListener("resize", measure)
    viewport?.addEventListener("scroll", measure)
    return () => {
      window.removeEventListener("resize", measure)
      viewport?.removeEventListener("resize", measure)
      viewport?.removeEventListener("scroll", measure)
    }
  }, [active])
  return {
    top: `calc(${AIR + pan}px + var(--nelo-safe-top, 0px))`,
    maxHeight: `calc(var(--vv-height) - ${AIR}px - var(--nelo-safe-top, 0px) - var(--spacing-nav-total) - var(--space-400))`,
  }
}
